import React, { useEffect, useRef, useMemo } from 'react';
import '../Report/ledgercss.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper } from '@mui/material';
import ReactToPrint from 'react-to-print';

import {
  fetchFirmLedgerData,
  selectFirmSalesLedgerData,
  selectFirmSalesOpeningData,
  fetchLedgerOpeningBal1,
} from '../../Store/PHPSlice/ReportApi/reportApi';

import FirmHeaderImg from '../FieldsComponents/FirmHeaderImg';

const FirmLedgerPrintTotalAmt = () => {
  const { firmId, fromDt, toDt, cat } = useParams();
  const dispatch = useDispatch();
  const componentRef = useRef();

  /* ================= REDUX ================= */
  const SalesData = useSelector(selectFirmSalesLedgerData) || [];
  const opening = useSelector(selectFirmSalesOpeningData) || [];

  const firmledgerLoading = useSelector(
    (state) => state.salesLedger.firmledgerLoading
  );
  const openingLoading1 = useSelector(
    (state) => state.salesLedger.openingLoading1
  );

  /* ================= EFFECT ================= */
  useEffect(() => {
    dispatch(fetchFirmLedgerData({ firmId, fmdt: fromDt, todt: toDt, cat }));
    dispatch(fetchLedgerOpeningBal1({ firmId, fmdt: fromDt, todt: toDt, cat }));
  }, [firmId, fromDt, toDt, cat, dispatch]);

  /* ================= HELPERS ================= */
  const formatDate = (dt) => {
    if (!dt || dt === "0") return "";
    return new Date(dt).toLocaleDateString("en-GB");
  };

  const rowStyle = (ctype, settlement_sts) => {
    if (ctype === "Sale" && settlement_sts === 1) {
      return { color: "#7f1d1d", fontWeight: "bold" };
    }
    switch (ctype) {
      case "Sale":
        return { color: "#1e3a8a", fontWeight: "bold" };
      case "Sale Rcpt":
        return { color: "#065f46", fontWeight: "bold" };
      case "Advance Rcpt":
        return { color: "#7c2d12", fontWeight: "bold" };
      case "RT Goods Rcpt":
        return { color: "#4c1d95", fontWeight: "bold" };
      default:
        return { color: "#000", fontWeight: "bold" };
    }
  };

  /* ================= TOTALS ================= */
  const totals = useMemo(() => {
    return SalesData.reduce(
      (acc, row) => {
        acc.total_amt += Number(row.total_amt || 0);
        acc.discnt_amt += Number(row.discnt_amt || 0);
        acc.freight_ch += Number(row.freight_ch || 0);
        acc.other_ch += Number(row.other_ch || 0);
        acc.cgst += Number(row.cgst || 0);
        acc.sgst += Number(row.sgst || 0);
        acc.igst += Number(row.igst || 0);
        acc.net_amt += Number(row.net_amt || 0);
        return acc;
      },
      {
        total_amt: 0,
        discnt_amt: 0,
        freight_ch: 0,
        other_ch: 0,
        cgst: 0,
        sgst: 0,
        igst: 0,
        net_amt: 0,
      }
    );
  }, [SalesData]);

  /* ================= RENDER ================= */
  return (
    <Grid item xs={12}>
      <Paper>
        <div ref={componentRef} style={{ padding: '20px' }}>

          {opening.length > 0 && (
            <FirmHeaderImg firmId={opening[0].firmId} />
          )}

          {(firmledgerLoading || openingLoading1) ? (
            <p style={{ padding: 20 }}>Loading...</p>
          ) : SalesData.length === 0 ? (
            <p style={{ padding: 20 }}>No Ledger data found</p>
          ) : (
            <>
              <table width="100%" style={{ textAlign: "center" }}>
                <tbody>
                  {fromDt !== "0" && toDt !== "0" && (
                    <tr>
                      <td style={{ fontSize: "13px" }}>
                        <b>From :</b> {formatDate(fromDt)} &nbsp;&nbsp;
                        <b>To :</b> {formatDate(toDt)}
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>

              <hr style={{ borderBottom: "2px dashed #000" }} />

              <table width="100%" cellPadding="6" style={{ borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Date</th>
                    <th align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Type</th>
                    <th align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Party Name</th>
                    <th align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Bill No.</th>
                    {/* <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Gross Amt</th>
                    <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Disc</th>
                    <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Freight</th>
                    <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Other</th>
                    <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>GST %</th>
                    <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>CGST</th>
                    <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>SGST</th>
                    <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>IGST</th> */}
                    <th align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>Net Amt</th>
                  </tr>
                </thead>

                <tbody>
                  {SalesData.map((row, i) => (
                    <tr key={i} style={rowStyle(row.rcptType, row.rcptsts)}>
                      <td align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{formatDate(row.dt)}</td>
                      <td align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.rcptType}</td>
                      <td align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.partyNm}</td>
                      <td align='left' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.billNo}</td>
                      {/* <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.total_amt}</td>
                      <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.discnt_amt}</td>
                      <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.freight_ch}</td>
                      <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.other_ch}</td>
                      <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.gstper}</td>
                      <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.cgst}</td>
                      <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.sgst}</td>
                      <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.igst}</td> */}
                      <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{row.net_amt}</td>
                    </tr>
                  ))}

                  <tr style={{ fontWeight: "bold", borderTop: "2px solid #000" }}>
                    <td  style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}colSpan={4} align="right">TOTAL</td>
                    {/* <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{totals.discnt_amt.toFixed(2)}</td>
                    <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{totals.freight_ch.toFixed(2)}</td>
                    <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{totals.other_ch.toFixed(2)}</td>
                    <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}></td>
                    <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{totals.cgst.toFixed(2)}</td>
                    <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{totals.sgst.toFixed(2)}</td>
                    <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{totals.igst.toFixed(2)}</td> */}
                    <td align='right' style={{fontWeight:"bold",borderRight:"1px solid #fff",borderLeft:"1px solid #fff"}}>{totals.net_amt.toFixed(2)}</td>
                  </tr>
                </tbody>
              </table>
            </>
          )}
        </div>

        <div style={{ margin: '20px' }}>
          <ReactToPrint
            trigger={() => <Button variant="contained">PRINT</Button>}
            content={() => componentRef.current}
          />
        </div>
      </Paper>
    </Grid>
  );
};

export default FirmLedgerPrintTotalAmt;
